const ALLOWED_DEEP_LINK_PREFIXES = ["connectmobile://auth-callback", "amail://auth-callback","connectcallmobile://auth-callback", "marisreesheetsmobile://auth-callback",
"marisreedocsmobile://auth-callback", "marisreeslidesmobile://auth-callback"];

const TRUSTED_ROOT_DOMAIN = "aaffice.com";

export function isMobileDeepLink(url: string): boolean {
  return ALLOWED_DEEP_LINK_PREFIXES.some(
    (prefix) => url === prefix || url.startsWith(`${prefix}?`),
  );
}

function isAllowedAbsoluteRedirect(raw: string): boolean {
  try {
    const url = new URL(raw);
 
    if (url.protocol !== "https:") {
      return false;
    } 
    return (
      url.hostname === TRUSTED_ROOT_DOMAIN ||
      url.hostname.endsWith(`.${TRUSTED_ROOT_DOMAIN}`)
    );
  } catch {
    return false;
  }
}

export function sanitizeRedirectTo(raw: string | null): string | null {
  if (!raw) return null;

  if (raw.startsWith("/") && !raw.startsWith("//")) {
    return raw;
  }

  if (isMobileDeepLink(raw)) {
    return raw;
  }

  if (isAllowedAbsoluteRedirect(raw)) {
    return raw;
  }

  return null;
}